<div [ngStyle]="pointerStyle">
  <wl-card heading="Land Details - भूमि विवरण">
    <mat-progress-bar *ngIf="showWaitingLR" mode="buffer"> Please Wait</mat-progress-bar>
    <form [formGroup]="landForm">
      <div class="w-full text-center">
        <div class="row">
          <div class="col-12 col-md-4 pt-20px-important">
            <div class="mt-neg20px">
              <p class="text-center pb-0 mb-0">कृपया जिला दर्ज करें </p>
              <p class="text-center pt-0 mt-0">(Select District) </p>
            </div>
          </div>
          <div class="col-12 col-md-5 pr-10px">

            <wl-autocomplete-bi label="District" placeholder="Select District" [options]="districts"
              formControlName="district" (selected)="getTehsil($event)" class="w-full"
              [disabled]="hideSubmitButton || disableBcoz5landsAlready">
            </wl-autocomplete-bi>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-4 pt-20px-important">
            <div class="mt-neg20px">
              <p class="text-center pb-0 mb-0">कृपया तहसील दर्ज करें </p>
              <p class="text-center pt-0 mt-0">(Select Tehsil) </p>
            </div>
          </div>
          <div class="col-12 col-md-5 pr-10px">
            <wl-autocomplete-bi label="Select Tehsil" placeholder="Select Tehsil" [options]="tehsils"
              formControlName="tehsil" (selected)="getHalka($event)" class="w-full" [disabled]="tehsilDisabled || disableBcoz5landsAlready">
            </wl-autocomplete-bi>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 pt-20px-important">
            <div class="mt-neg20px">
              <p class="text-center pb-0 mb-0">कृपया हलका दर्ज करें </p>
              <p class="text-center pt-0 mt-0">(Select Halka) </p>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 pr-10px">
            <wl-autocomplete-bi label="Select Halka" placeholder="Select Halka" [options]="halka"
              formControlName="halka" (selected)="getVillage($event)" class="w-full" [disabled]="halkaDisabled || disableBcoz5landsAlready">
            </wl-autocomplete-bi>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-4 pt-20px-important">
            <div class="mt-neg20px">
              <p class="text-center pb-0 mb-0">कृपया ग्राम दर्ज करें </p>
              <p class="text-center pt-0 mt-0">(Select Village) </p>
            </div>
          </div>
          <div class="col-12 col-md-5 pr-10px">
            <wl-autocomplete-bi label="Select Village" placeholder="Select Village" [options]="villages"
              formControlName="village" (selected)="onSelectVillage($event)" class="w-full"
              [disabled]="villageDisabled || disableBcoz5landsAlready"></wl-autocomplete-bi>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-4 pt-20px-important">
            <p class="text-center pb-0 mb-0">खसरा नंबर दर्ज करें</p>
            <p class="text-center pt-0 mt-0">(Enter Khasra) </p>
          </div>
          <!-- <div class="col-xs-0 col-sm-0 col-md-1 col-lg-1 col-xl-1 col-xxl-1">
      </div> -->
          <div class="col-12 col-md-5 pr-10px">
            <!-- <md-input-container class="w-full mt-10px">
              <input mdInput type="text" formControlName="khasra" [readonly]="khasraDisabled || disableBcoz5landsAlready">
            </md-input-container> -->
            <mat-form-field class="w-full mt-10px">
              <input matInput type="text" formControlName="khasra" [readonly]="khasraDisabled || disableBcoz5landsAlready">
            </mat-form-field>
          </div>

        </div>
        <div class="row">
          <div class="col-12 col-md-4">

          </div>
          <div class="col-12 col-md-5 w-full text-center">
            <button class="w-50pct mybutton" (click)="fetchLandRecords(landForm.value)"
              [disabled]="landForm.controls['district'].invalid || landForm.controls['tehsil'].invalid || landForm.controls['village'].invalid || landForm.controls['khasra'].invalid || isFetchButtonDisabled || disableBcoz5landsAlready">भूमि
              विवरण प्राप्त करें <br> (Fetch Land Details)</button>
            <img class="display-inline h-30px ml-5px mb-neg18px"
              src="../../../assets/green-tick.png" *ngIf="isFetchButtonDisabled">
          </div>
        </div>
      </div>
    </form>

  </wl-card>

  <wl-card heading="Land Details Output" *ngIf="noOfDocuments">
    <form novalidate [formGroup]="ownershipForm">

      <div formArrayName="bhoomi_details">
        <div *ngFor="let bhoomi_detail of bhoomi_details().controls; let i=index" [formGroupName]="i">
          <br>


          <div class="text-center">

          </div>
          <div class="container">
            <div class="row">
              <div class="col-12 col-md-4">
                <label></label>
              </div>
              <!-- <div class="col-4">
              <button *ngIf="docPath" (click)="downloadPdf(i)" class="h-18px mybutton"
                target="_blank">View
                Document - {{(noOfDocuments)-i}}</button>
            </div> -->
              <div class="col-12 col-md-11 text-right" *ngIf="showDelete">

                <img *ngIf="showDelete" class="deleteIcon h-30px"
                  src="../../../../assets/fontawesome-web/svgs/regular/trash-can.svg"
                  (click)="deleteRecord(i)">
              </div>
            </div>
          </div>

          <br>

          <div class="container">
            <div class="row">
              <div class="col-12 col-md-4">
                <p>Land BRE Status</p>
              </div>
              <div class="col-12 col-md-5">
                <p class="text-left font-bold">
                  {{breArray[i]=="failure"?"Failure":breArray[i]=="success"?"Success":breArray[i]}}</p>
              </div>
            </div>
          </div>

          <wl-input type="text" label="Name(as per KYC from CBS)" placeholder="Name" formControlName="name_as_per_bhumi"
            class="form-control" [readonly]=true></wl-input>
          <wl-input type="text" label="Land Area (in Hectares)" placeholder="Land Area(in Hectare)"
            formControlName="land_area" class="form-control" [readonly]=true></wl-input>
          <wl-input type="text" label="Land Ownership (as per Bhumi report)" placeholder="Land Ownership"
            formControlName="land_ownership" class="form-control" [readonly]=true></wl-input>
          <wl-input type="text" label="Charge Status (as per Bhumi report)" placeholder="Charge Details"
            formControlName="charge_details" class="form-control" [readonly]=true></wl-input>

          <!-- <div class="text-center">
            <br>
            <button class="mybutton" (click)="submitBhoomiDetail(((noOfDocuments)-i-1));bhoomiForm.reset()" [disabled]="readOnlyArray && readOnlyArray[i]?readOnlyArray[i]:false">Submit</button> 
          </div> -->

          <div class="h-1px bg-e4e4e4 mt-32px mb-10px"></div>
        </div>
      </div>

      <br>

      <div class="text-center">
        <button class="mybutton" (click)="submitLandRecords()" [disabled]="disableSubmitLandRecords || hideSubmitButton">Submit</button>
        <!-- <button class="mybutton" (click)="submitLandRecords()" >Submit Land Records</button> -->
      </div>
    </form>
  </wl-card>
</div>

